import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-solo',
  templateUrl: './solo.component.html',
  styleUrls: ['./solo.component.scss']
})
export class SoloComponent implements OnInit {
  game = {
    maxSets: 13,
    round: 1,
    targetScore: 200,
    roundBets: 0,
    roundSets: 0,
    quickBets: [3, 4, 6, 7]
  }
  players = [
    {
      name: 'Player 1',
      id: 0,
      points: 0,
      bags: 0,
      sets: 0,
      bet: 0,
      history: []
    },
    {
      name: 'Player 2',
      id: 1,
      points: 0,
      bags: 0,
      sets: 0,
      bet: 0,
      history: []
    }
  ]
  localstorageSave(): void {
    localStorage.setItem('spadesologame', JSON.stringify(this.game))
    localStorage.setItem('spadesoloplayers', JSON.stringify(this.players))
  }
  resetPoints(): void {
    for(let i = 0; i < this.players.length; i++) { // setting points to 0
      this.players[i].points = 0
      this.players[i].bags = 0
      this.players[i].sets = 0
      this.players[i].bet = 0
      this.players[i].history = []
    }
    this.localstorageSave()
    window.location.reload()
  }
  resetLocalStorage(): void {
    localStorage.removeItem('spadesologame')
    localStorage.removeItem('spadesoloplayers')
    window.location.reload()
  }
  addPlayer(): void {
    this.players.push(
      {
        name: 'Player ' + (this.players.length + 1),
        id: (this.players.length),
        points: 0,
        bags: 0,
        sets: 0,
        bet: 0,
        history: []
      }
    )
    this.localstorageSave()
  }
  removePlayer(): void {
    this.players.pop()
    this.localstorageSave()
  }
  betChange(player:any, e:any): void {
    player.bet = parseInt(e.target.value)
  }
  setChange(player:any, e:any): void {
    player.sets = parseInt(e.target.value)
  }
  setsChange(e:any): void {
    this.game.quickBets = []
    this.game.maxSets = parseInt(e.target.value);
    const medianBet = Math.round(this.game.maxSets / this.players.length)
    for (let i = (medianBet - 2); i < (medianBet + 2); i++) {
      this.game.quickBets.push(i)
    }
  }
  playerBet(player:any, x:any) {
    if (x === 'add') {
      player.bet++
    } else {
      player.bet--
    }
    this.updateRoundBets();
  }
  playerSets(player:any, x:any) {
    if (x === 'add') {
      player.sets++
    } else {
      player.sets--
    }
    this.game.roundSets = 0
    this.players.forEach(player => {
      this.game.roundSets = this.game.roundSets + player.sets;
    });
  }
  targetChange(e:any) {
    this.game.targetScore = parseInt(e.target.value)
  }
  quickBetClick(player:any, e:any) {
    player.bet = parseInt(e.target.value);
    this.updateRoundBets();
  }
  updateRoundBets() {
    this.game.roundBets = 0
    this.players.forEach(player => {
      this.game.roundBets = this.game.roundBets + player.bet;
    });
  }
  submitResults (): void {
    
    this.players.map((player, i) => {
     let roundPoints = ''
      if (player.bet > player.sets) { // failed bet
        player.points -= player.bet * 10
        roundPoints = ('-' + (player.bet * 10)).toString()
      } else if (player.bet === player.sets) {
        if (player.bet === 0) { // if bet === 0 then 100 points
          player.points += 100
          roundPoints = ('+' + (100)).toString()
        } else if (player.bet === 10) { // if bet === 10 then 200 points
          player.points += 200
          roundPoints = ('+' + (200)).toString()
        } else { // else normal x10 points
          player.points += player.bet * 10
          roundPoints = ('+' + (player.bet * 10)).toString()
        }
      } else if (player.bet < player.sets) { // bet is smaller than result === getting bags
        if (player.bet === 0) { // if bet === 0 then - 100 points
          player.points -= 100
          roundPoints = ('-' + (100)).toString()
        } else {
          player.points += player.bet * 10 + (player.sets - player.bet)
          roundPoints = ('+' + (player.bet * 10 + (player.sets - player.bet))).toString()
          player.bags += (player.sets - player.bet)
        }
      }
      
      player.history.push({
        bags: player.bags,
        bet: player.bet,
        score: roundPoints,
        sets: player.sets,
        round: this.game.round,
      })

      player.bet = 0
      player.sets = 0
    })
    this.game.round++
    this.game.roundBets = 0
    this.game.roundSets = 0
    this.localstorageSave()
  }

  constructor() { }

  ngOnInit(): void {
    const spadesologame = localStorage.getItem('spadesologame')
    const spadesoloplayers = localStorage.getItem('spadesoloplayers')
    if (spadesologame) {
      this.game = JSON.parse(spadesologame)
    }
    if (spadesoloplayers) {
      this.players = JSON.parse(spadesoloplayers)
    }
  }
}
